import * as React from 'react';
export const HMSvg = React.forwardRef(function HMSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#43458B',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M1.346 3.964H0V2.036h3v-.107L.748.44c.267-.213.59-.36.943-.415L3 .89V0h2v2.036h.046L8 .08v1.04l-1.383.915H8v1.928H5v.083l2.934 1.941h-1.57L5 5.086V6H3V3.964h-.082L0 5.894v-1.04l1.346-.89Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M3 1.93v.106H1.587L.203 1.12C.333.856.52.624.748.44L3 1.93Zm2-.881L6.586 0H8v.104L5.08 2.036H5v-.987ZM2.92 3.964H3v.987L1.414 6H0v-.104l2.92-1.932Zm3.493 0L8 5.014V6h-.08L5 4.07v-.106h1.413ZM8 3.427H4.444V6h-.888V3.427H0v-.854h3.556V0h.888v2.573H8v.854Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M13.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2-5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM10 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2.5 3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-8.883 1.236-.556.53c-.097.093-.253.015-.244-.12l.055-.78-.749-.118c-.13-.02-.169-.195-.06-.271l.626-.442-.378-.678c-.066-.118.042-.257.168-.217l.725.229.278-.727a.143.143 0 0 1 .27 0l.279.727.724-.23c.126-.04.234.1.169.218l-.378.678.625.442c.11.076.07.25-.06.271l-.749.119.055.779c.01.135-.147.213-.243.12l-.557-.53Z',
      }),
    ),
  );
});
HMSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var HM = {
  category: 'flag',
  colorable: false,
  name: 'HM',
  svg: HMSvg,
};
